import { getConfigName } from "@helpers/funciones";
import OfertaVivemoto from "../../vivemoto/OfertaVivemoto";
import OfertaCredivive from "../../credivive/OfertaCredivive";
import OfertaDefault from "@components/OfertaDefault";

const ofertasComponent: Record<string, React.FC> = {
  vivemoto: OfertaVivemoto,
  credivive: OfertaCredivive,
};

const Oferta = () => {
    const configName = getConfigName(window.location.href);
  
    const Component = ofertasComponent[configName];
  
    if (!Component) {
      return (
       <OfertaDefault />
      );
    }
  
    return <Component />;
};

export default Oferta;
